import { render, staticRenderFns } from "./PrimeiraEtapaAditivoApostila.vue?vue&type=template&id=0a376d8d&scoped=true"
import script from "./PrimeiraEtapaAditivoApostila.vue?vue&type=script&lang=js"
export * from "./PrimeiraEtapaAditivoApostila.vue?vue&type=script&lang=js"
import style0 from "./PrimeiraEtapaAditivoApostila.vue?vue&type=style&index=0&id=0a376d8d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a376d8d",
  null
  
)

export default component.exports